// extracted by mini-css-extract-plugin
export var activeFilterButton = "_o9-c";
export var backButton = "_o9-4";
export var backIcon = "_o9-5";
export var chevronShortcut = "_o9-6";
export var container = "_o9-1";
export var editor = "_o9-8";
export var editorWrapper = "_o9-7";
export var prefix = "_o9-2";
export var searchIcon = "_o9-3";
export var suffix = "_o9-9";
export var suffixContent = "_o9-a";
export var suffixText = "_o9-b";
export var wrapper = "_o9-0";